import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Typography, CircularProgress, Paper } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { unsubscribeUserData } from "../api/userApi";

const UnsubscribePage = () => {
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("userId");
  const [status, setStatus] = useState("loading"); // 'loading', 'success', 'error'
  useEffect(() => {
    const unsubscribeUser = async () => {
      try {
        const response = await unsubscribeUserData(userId);
        setStatus("success");
      } catch (error) {
        setStatus("error");
      }
    };

    unsubscribeUser();
  }, [userId]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f4f6f8",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        px: 2
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 4,
          borderRadius: 4,
          textAlign: "center",
          maxWidth: 400,
          width: "100%"
        }}
      >
        {status === "loading" && (
          <>
            <CircularProgress color="warning" sx={{ mb: 3 }} />
            <Typography variant="h6" color="text.secondary">
              Processing your request...
            </Typography>
          </>
        )}

        {status === "success" && (
          <>
            <CheckCircleOutlineIcon
              color="success"
              sx={{ fontSize: 50, mb: 2 }}
            />
            <Typography variant="h5" gutterBottom>
              You're Unsubscribed
            </Typography>
            <Typography color="text.secondary">
              You will no longer receive emails from us.
            </Typography>
          </>
        )}

        {status === "error" && (
          <>
            <ErrorOutlineIcon color="error" sx={{ fontSize: 50, mb: 2 }} />
            <Typography variant="h5" gutterBottom>
              Something went wrong
            </Typography>
            <Typography color="text.secondary">
              We couldn't process your request. Please try again later.
            </Typography>
          </>
        )}
      </Paper>
    </Box>
  );
};

export default UnsubscribePage;
